import React from 'react';
import { labelStyles, LabelProps } from './styles';

const Label14: React.FC<LabelProps> = ({
    children,
    className,
    style,
    isPrimary,
    isBold,
}) => {
    const { label14Styles, primary, bold } = labelStyles();
    const classes = `${className} ${label14Styles} ${
        isPrimary ? primary : ''
    } ${isBold ? bold : ''}`;
    return (
        <div className={classes} style={style}>
            {children}
        </div>
    );
};

export default Label14;
